import {ModuleTopic} from '@cp/model';
import getExamModuleDoc from '../examModules/getExamModuleDoc';
import listStudiesDoc from './listStudiesDoc';

export default async function getModuleTopicsWithStudyDoc(moduleId: string): Promise<ModuleTopic[]> {
  const [moduleDoc, studies] = await Promise.all([getExamModuleDoc(moduleId), listStudiesDoc(moduleId)]);
  const moduleTopics = moduleDoc?.topics ?? [];
  const studyTopicSet = new Set(studies.map((study) => study.id));
  return moduleTopics.filter((topic) => studyTopicSet.has(topic.topic));
}
